import { useCallback, useContext, useMemo, useState } from 'react';
import { useMutation, useQuery } from '@apollo/client';
import { handleGQLError } from '../../../../../Utils/Error';
import { useValidateFakturadelTillaggsinfo } from './Components/Kontering/Components/Tillaggsinfo/Utils/TillaggsinfoUtils';
import {
  BusinessCollectionCompType,
  IObjektVy,
} from '../../../../../Types/ObjektVy';
import { collectionCompToObjektVy } from '../../../_Common/Components/BusinessCollectionComponents/BusinessCollectionUtils';
import BusinessDataForm, {
  BusinessDataFormContext,
} from '../../../_Common/Components/BusinessCollectionComponents/BusinessDataForm/BusinessDataForm';
import {
  FakturaDelQuery_node_TEDLRFakturaDel,
  FakturaDelQuery,
  FakturaDelQueryVariables,
} from './Queries/_QueryTypes/FakturaDelQuery';
import query from './Queries/FakturaDelQuery.gql';
import { IClientBusinessModel } from '../../../../../Types/ClientModelTypes';
import clientAvenyModel from '../../../../../Model/clientAvenyModel';
import ObjektVy from '../../../_Common/Components/BusinessCollectionComponents/ObjektVy/ObjektVy';
import ObjektVySida from '../../../_Common/Components/BusinessCollectionComponents/ObjektVySida/ObjektVySida';
import Attribut from '../../../_Common/Components/BusinessCollectionComponents/Attribut/Attribut';
import AttributGrupp from '../../../_Common/Components/BusinessCollectionComponents/AttributGrupp/AttributGrupp';
import { Attestanter } from './Components/Attestanter';
import { AttestMeddelande } from '../LeverantorFaktura/Components/AttestMeddelande/AttestMeddelande';
import FakturaBilderComponent from '../LeverantorFaktura/FakturaBilderComponent';
import {
  IFormData,
  IValidateFn,
  removeIdsFromNewAssociations,
  defaultEditMenuCancelButton,
  defaultEditMenuSaveButton,
  IEditMenuAction,
} from '../../../_Common/Components/BusinessCollectionComponents/BusinessDataForm/Utils/BusinessDataFormUtils';
import UpdateMutation from './Mutations/FakturaDelUpdateMutation.gql';
import {
  FakturaDelUpdateMutationVariables,
  FakturaDelUpdateMutation,
} from './Mutations/_QueryTypes/FakturaDelUpdateMutation';
import { ActiveDatabaseContext } from '../../../../../Components/ActiveDatabaseContext/ActiveDatabaseContext';
import { AssociationList } from '../../../_Common/Components/BusinessCollectionComponents/AssociationList/AssociationList';
import { IAssociationListConfig } from '../../../_Common/Components/BusinessCollectionComponents/AssociationList/AssociationList';
import { ObjektVyKort } from '../../../_Common/Components/BusinessCollectionComponents/ObjektVyKort/ObjektVyKort';
import { Kontering } from './Components/Kontering/Kontering';
import { LoginStateContext } from '../../../../Login/Contexts/LoginStateContext/LoginStateContext';
import FakturaDelContextManager from './Components/FakturaDelContextManager/FakturaDelContextManager';
import ObjektVyKolumner, {
  ObjektVyKolumn,
} from '../../../_Common/Components/BusinessCollectionComponents/ObjektVyKolumner/ObjektVyKolumner';
import KonteringContext from '../../../_Common/Components/KonteringManager/KonteringContext';
import FakturaAttestPrintModal from './Components/FakturaAttestPrintModal/FakturaAttestPrintModal';
import FakturaAttestHandleCertifiersModal from './Components/FakturaAttestHandleCertifiersModal/FakturaAttestHandleCertifiersModal';
import AttestMessageButtons from './Components/AttestMessageButtons/AttestMessageButtons';
import ReturnFakturaDialog from './Components/ReturnFakturaDialog/ReturnFakturaDialog';
import { TEDLRFakturaDelAttestMinaStatusEnum } from '../../../../../globalQueryTypes';
import HandleCertifiersButton from './Components/HandleCertifiersButton/HandleCertifiersButton';
import { AvenyContext } from '../../../../AvenyContext';
import ShowKodBehButton from './Components/ShowKodBehButton/ShowKodBehButton';
import KodbehInfoModal from './Components/KodbehInfoModal/KodbehInfoModal';
import {
  isRetakeButtonDisabled,
  retakeFakturaattest,
  isRetakeHidden,
  isAttesteraButtonDisabled,
  isSaveButtonDisabled,
  attesteraFakturadel,
  ButtonTypeEnum,
  validateMessage,
  getBildFaktura,
} from './Utils/FakturadelUtils';
import { StandardRutinContext } from '../../../_StandardRutin/StandardRutinContext';
import { AttestMessageContextProvider } from './Components/AttestMessageContext/AttestMessageContext';
import { FakturaattestWrapperContext } from '../../Rutiner/FakturaDel/Contexts/FakturaattestWrapperContext';
import {
  BusinessCollectionMenuItemHookType,
  defaultBusinessCollectionMenuItem,
} from '../../../_Common/Components/BusinessCollectionComponents/BusinessCollectionMenu/Utils/BusinessCollectionMenuUtils';
import FakturaDelContext from './Components/FakturaDelContextManager/FakturaDelContext';
import EDTypography from '../../../../../BaseComponents/Typography/EDTypography';
import EDTooltip from '../../../../../BaseComponents/Tooltip/EDTooltip';
import { selectedId } from '../../../../../Components/MasterDetail/MasterDetailUtils';
import EDAvenyProgress from '../../../../../BaseComponents/ProgressIndicators/AvenyProgress/EDAvenyProgress';
import EventLogModal from './Components/EventLogModal/EventLogModal';
import { useValidateKvittering } from '../LeverantorFaktura/Utils/AttestMeddelandeUtils';
import {
  IsTillaggsInfoActiveQuery,
  IsTillaggsInfoActiveQueryVariables,
} from './Components/Kontering/Queries/_QueryTypes/IsTillaggsInfoActiveQuery';
import TillaggsInfoQuery from './Components/Kontering/Queries/IsTillaggsInfoActiveQuery.gql';
import { useValidateFakturaDel } from './Hooks/useValidateFakturaDel';
import {
  ISelectedDetailQueryOptions,
  INodeResultData,
  useSelectedDetailQuery,
} from '../../../../../Components/QueryComponents/SelectedDetailQuery/useSelectedDetailQuery';
import BokfKonteringModal from './Components/BokfKonteringModal/BokfKonteringModal';
import ShowBokfKonteringarButton from './Components/ShowBokfKonteringarButton/ShowBokfKonteringarButton';
import { useValidateKonteringKombination } from './Hooks/useValidateKonteringKombination';
import ShowFastRegButton from './Components/ShowFastRegButton/ShowFastRegButton';
import { LRSysOptionsQuery_db_SYSOptions_All } from './Queries/LRSysOptionQuery/_QueryTypes/LRSysOptionsQuery';
import { FakturaDelType__Associations_Faktura } from './Queries/_QueryTypes/FakturaDelType';
import { resolveImagePromises } from '../../../../../Components/Fakturabild/Components/ImgFaktura';
import Logger from '../../../../../Utils/Logger';
import FakturaattestMailFakturaBildModal from './Components/FakturaattestMailFakturaBildModal/FakturaattestMailFakturaBildModal';
import FakturaAttestSnabbRegModal from './Components/FakturaAttestSnabbRegModal/FakturaAttestSnabbRegModal';
import { useIsLargeScreen } from '../../../../../Hooks/useFullscreenView';
import { useValidatePeriodDates } from './Hooks/useValidatePeriodDates';
import { useValidateSvenskMoms } from './Hooks/useValidateSvenskMoms';
import { useValidateUtlandskMoms } from './Hooks/useValidateUtlandskMoms';

const fakturaDelModel: IClientBusinessModel =
  clientAvenyModel.LR.BusinessModels.LRFakturaDel;
const fakturabildModel: IClientBusinessModel =
  clientAvenyModel.LR.BusinessModels.LRFakturabild;
const levfaktAttestantModel: IClientBusinessModel =
  clientAvenyModel.LR.BusinessModels.LRLevfaktAttestant;

const useAddDokumentBusinessCollectionMenuItem: BusinessCollectionMenuItemHookType =
  () => {
    const fakturadelContext = useContext(FakturaDelContext);

    return {
      ...defaultBusinessCollectionMenuItem.Add,
      isDisabled: !fakturadelContext.jagAttesterar,
    };
  };

const prefetchNextOrprevImage = (
  data: INodeResultData,
  lrLoggPrevNextImageError: boolean,
  nextOrPrev: string
) => {
  const fakturaData: FakturaDelType__Associations_Faktura =
    data.node?._Associations?.Faktura;
  const bildUrler =
    fakturaData._Associations?.Fakturasidor?.[0]?._Associations?.Blob
      ?.BildUrler;

  const firstImgUrl = bildUrler?.split('|')[0];

  if (firstImgUrl != undefined) {
    resolveImagePromises([firstImgUrl])
      .then(
        () => {},
        reason => {
          if (lrLoggPrevNextImageError) {
            Logger.error(
              `Fel vid inhämtning av förgående eller nästa fakturas bilder`,
              {
                bildUrler: bildUrler,
                blob: fakturaData._Associations?.Fakturasidor?.[0]._Associations
                  ?.Blob,
                firstImgUrl: firstImgUrl,
                nextOrPrev: nextOrPrev,
                reason: reason,
              }
            );
          }
        }
      )
      .catch(error => {
        if (lrLoggPrevNextImageError) {
          Logger.error(
            `Fel vid inhämtning av förgående eller nästa fakturas bilder`,
            {
              bildUrler: bildUrler,
              blob: fakturaData._Associations?.Fakturasidor?.[0]._Associations
                ?.Blob,
              firstImgUrl: firstImgUrl,
              nextOrPrev: nextOrPrev,
              error: error,
            }
          );
        }
      });
  }
};

const Fakturadel: BusinessCollectionCompType = props => {
  const [returnFakturaDialogOpen, setReturnFakturaDialogOpen] = useState(false);
  const [haveAttesterat, setHaveAttesterat] = useState(false);
  const todaysDate = useMemo(() => new Date().toLocaleDateString('sv-SE'), []);
  const standardRutinContext = useContext(StandardRutinContext);
  const avenyContext = useContext(AvenyContext);
  const { openChoiceCallback, setOpenChoiceDialog } = avenyContext;
  const { activeDatabase } = useContext(ActiveDatabaseContext);
  const konteringContext = useContext(KonteringContext);
  const loginStateContext = useContext(LoginStateContext);
  const fakturaattestContext = useContext(FakturaattestWrapperContext);

  const [haveChanges, setHaveChanges] = useState(false);
  const validateKontering = useValidateKonteringKombination();
  const validateKvittering = useValidateKvittering();
  const validateFakturadel = useValidateFakturaDel();
  const validatePeriodDates = useValidatePeriodDates();
  const validateSvenskMoms = useValidateSvenskMoms();
  const validateUtlandskMoms = useValidateUtlandskMoms();

  const [handleCertifiersOpen, setHandleCertifiersOpen] = useState(false);
  const [printMenuOpen, setPrintMenuOpen] = useState(false);
  const [mailDialogOpen, setMailDialogOpen] = useState(false);
  const [kodbehInfoOpen, setKodbehInfoOpen] = useState(false);
  const [eventLogModalOpen, setEventLogModalOpen] = useState(false);
  const [fastRegOpen, setFastRegOpen] = useState(false);
  const [adjustedKonteringarOpen, setAdjustedKonteringarOpen] = useState(false);
  const [messageEditModeID, setMessageEditModeID] = useState('');
  const [messageReciverID, setMessageReciverID] = useState<string | undefined>(
    undefined
  );

  const isLarge = useIsLargeScreen();

  const lrLoggPrevNextImageError: boolean = useMemo(() => {
    return (
      fakturaattestContext.sysOptions?.find(
        (option: LRSysOptionsQuery_db_SYSOptions_All) =>
          option?.OptionKey === 'LR_LOGG_PREV_NEXT_IMAGE_ERROR'
      )?.OptionData === 'Y'
    );
  }, [fakturaattestContext.sysOptions]);

  const options: ISelectedDetailQueryOptions<
    FakturaDelQuery,
    FakturaDelQueryVariables
  > = useMemo(
    () => ({
      queryOptions: {
        variables: {
          id: selectedId(props.id) ?? '',
          date: todaysDate,
        },
        fetchPolicy: 'cache-first',
        onError: handleGQLError,
      },
      nextFetchOnCompleted: data => {
        prefetchNextOrprevImage(data, lrLoggPrevNextImageError, 'next');
      },
      prevFetchOnCompleted: data => {
        prefetchNextOrprevImage(data, lrLoggPrevNextImageError, 'prev');
      },
    }),
    [lrLoggPrevNextImageError, props.id, todaysDate]
  );
  const {
    nodeData,
    loading: nodeLoading,
    refetch,
    error: fakturaDelQueryError,
  } = useSelectedDetailQuery<
    FakturaDelQuery,
    FakturaDelQuery_node_TEDLRFakturaDel,
    FakturaDelQueryVariables
  >(query, props.id, options);

  const [mutation, { loading: mutationLoading, error }] = useMutation<
    FakturaDelUpdateMutation,
    FakturaDelUpdateMutationVariables
  >(UpdateMutation, {
    onCompleted: () => {
      if (haveAttesterat) {
        standardRutinContext.selectNextDetail.current?.(true);
        setHaveAttesterat(false);
      }
    },
    onError: handleGQLError,
  });

  const tillaggsInfoQuery = useQuery<
    IsTillaggsInfoActiveQuery,
    IsTillaggsInfoActiveQueryVariables
  >(TillaggsInfoQuery, {
    variables: { dbName: activeDatabase ?? '' },
  });

  const lrUseSnabbReg: boolean = useMemo(() => {
    return (
      fakturaattestContext.sysOptions?.find(
        (option: LRSysOptionsQuery_db_SYSOptions_All) =>
          option?.OptionKey === 'LR_USE_SNABBREG'
      )?.OptionData === 'Y'
    );
  }, [fakturaattestContext.sysOptions]);

  const isFIActive =
    tillaggsInfoQuery.data?.db?.EKTillaggsinfo_All?.find(
      tillaggsInfo => tillaggsInfo.BENAMNING === 'Förbrukningsinventarier'
    )?.AKTIV ?? false;

  const showWarning =
    nodeData?.AttestMinaStatus ==
      TEDLRFakturaDelAttestMinaStatusEnum.MOTTAGNINGSATTESTERAS ||
    nodeData?.AttestMinaStatus ==
      TEDLRFakturaDelAttestMinaStatusEnum.BESLUTSATTESTERAS;

  const validateFakturadelTillaggsinfo = useValidateFakturadelTillaggsinfo(
    isFIActive,
    showWarning
  );

  const updateFunction = useCallback(
    (values: IFormData) => {
      const newValues = removeIdsFromNewAssociations(values ?? {});
      return mutation({
        variables: {
          date: new Date().toLocaleDateString('se-SV').toString(),
          db: activeDatabase || '',
          values: {
            id: nodeData?.id ?? '',
            _version: nodeData?._version ?? 1,
            ...newValues,
          },
        },
      });
    },
    [mutation, activeDatabase, nodeData?.id, nodeData?._version]
  );

  const editMenuAttestera: IEditMenuAction = useMemo(
    () => ({
      id: 'attestera',
      isDisabled: params =>
        isAttesteraButtonDisabled(
          params.businessDataFormContext,
          konteringContext.konteringValidationQueryLoading
        ),
      isHidden: isRetakeHidden(
        ButtonTypeEnum.ATTESTERA,
        loginStateContext.sign,
        fakturaattestContext.reservForData
      ),
      label: (
        <EDTooltip title="Alt+A">
          <EDTypography component="span" color="inherit" variant="button">
            <EDTypography
              underlined
              color="inherit"
              component="span"
              variant="button"
            >
              A
            </EDTypography>
            ttestera
          </EDTypography>
        </EDTooltip>
      ),
      shortLabel: 'Attestera',
      onClick: params => {
        setHaveAttesterat(true);
        attesteraFakturadel(
          params.businessDataFormContext,
          loginStateContext.sign,
          fakturaattestContext.reservForData
        );
      },
      primary: true,
      icon: 'check_circle_outline',
      hideIconIfNotFloating: true,
    }),
    [
      loginStateContext.sign,
      fakturaattestContext.reservForData,
      konteringContext.konteringValidationQueryLoading,
    ]
  );

  const editMenuActionSkickaTillbakaFaktura: IEditMenuAction = useMemo(
    () => ({
      id: 'returnFaktura',
      label: 'Skicka tillbaka',
      onClick: params => {
        if (params.businessDataFormContext.formState.formHasChanged) {
          setOpenChoiceDialog(true, () => setReturnFakturaDialogOpen(true));
        } else {
          setReturnFakturaDialogOpen(true);
        }
      },
      primary: true,
      flat: true,
      isDisabled: params =>
        params.businessDataFormContext.data?.AttestMinaStatus !==
          TEDLRFakturaDelAttestMinaStatusEnum.MOTTAGNINGSATTESTERAS &&
        params.businessDataFormContext.data?.AttestMinaStatus !==
          TEDLRFakturaDelAttestMinaStatusEnum.BESLUTSATTESTERAS &&
        params.businessDataFormContext.data?.AttestMinaStatus !==
          TEDLRFakturaDelAttestMinaStatusEnum.KONTROLLATTESTERAS
          ? 'Du måste vara på tur att attestera för att kunna skicka tillbaka fakturan'
          : false,
      icon: 'turn_left_outlined',
      hideIconIfNotFloating: true,
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  const dokConfig: IAssociationListConfig = useMemo(
    () => ({
      inCard: true,
      defaultVisningstyp: 'lista',
      businessCollectionMenuItems: [useAddDokumentBusinessCollectionMenuItem],
      showDeleteIcon:
        nodeData?.AttestMinaStatus ===
          TEDLRFakturaDelAttestMinaStatusEnum.BESLUTSATTESTERAS ||
        nodeData?.AttestMinaStatus ===
          TEDLRFakturaDelAttestMinaStatusEnum.MOTTAGNINGSATTESTERAS ||
        nodeData?.AttestMinaStatus ===
          TEDLRFakturaDelAttestMinaStatusEnum.KONTROLLATTESTERAS,
    }),
    [nodeData?.AttestMinaStatus]
  );

  const editMenuSave: IEditMenuAction = useMemo(
    () => ({
      ...defaultEditMenuSaveButton,
      label: (
        <EDTooltip title="Alt+S">
          <EDTypography component="span" color="inherit" variant="button">
            <EDTypography
              underlined
              color="inherit"
              component="span"
              variant="button"
            >
              S
            </EDTypography>
            para
          </EDTypography>
        </EDTooltip>
      ),
      shortLabel: 'Spara',
      primary: true,
      flat: true,
      hideIconIfNotFloating: true,

      isDisabled: params => {
        const saveButtonDisabled = isSaveButtonDisabled(
          params.businessDataFormContext,
          konteringContext.konteringValidationQueryLoading
        );
        setHaveChanges(!saveButtonDisabled);
        return saveButtonDisabled;
      },
      onClick: ({ businessDataFormContext, editMenuOnCancel: stopLoading }) => {
        setMessageEditModeID('');
        businessDataFormContext.saveForm(
          undefined,
          () => {
            if (avenyContext.openChoiceDialog) {
              setOpenChoiceDialog(false);
              openChoiceCallback?.();
              stopLoading?.();
            } else {
              businessDataFormContext.formStateDispatch({
                type: 'VALIDATE',
              });
            }
          },
          () => {
            if (avenyContext.openChoiceDialog) {
              stopLoading?.();
            }
          }
        );
      },
    }),

    [
      openChoiceCallback,
      avenyContext.openChoiceDialog,
      setOpenChoiceDialog,
      konteringContext.konteringValidationQueryLoading,
    ]
  );

  const editMenuUndo: IEditMenuAction = useMemo(
    () => ({
      ...defaultEditMenuCancelButton,
      label: ({ businessDataFormContext }) =>
        businessDataFormContext.directEditMode ? (
          <EDTooltip title="Alt+Z">
            <EDTypography component="span" color="inherit" variant="button">
              Ångra
            </EDTypography>
          </EDTooltip>
        ) : (
          <span>Avbryt</span>
        ),
      shortLabel: ({ businessDataFormContext }) =>
        businessDataFormContext.directEditMode ? 'Ångra' : 'Avbryt',
      onClick: ({ businessDataFormContext }) => {
        setMessageEditModeID('');
        businessDataFormContext?.formStateDispatch({ type: 'RESET' });
        businessDataFormContext?.formStateDispatch({ type: 'VALIDATE' });
      },
    }),
    []
  );

  const editMenuRetake: IEditMenuAction = useMemo(
    () => ({
      flat: false,
      id: 'retake',
      icon: 'replay_outlined',
      hideIconIfNotFloating: true,
      isDisabled: params =>
        isRetakeButtonDisabled(
          fakturaattestContext.reservForData,
          loginStateContext.sign
        )(params, konteringContext.konteringValidationQueryLoading),
      isHidden: isRetakeHidden(
        ButtonTypeEnum.ATERTA,
        loginStateContext.sign,
        fakturaattestContext.reservForData
      ),
      label: 'Återta',
      onClick: params => {
        retakeFakturaattest(
          fakturaattestContext.reservForData,
          loginStateContext.sign
        )(params);
      },
      primary: true,
    }),
    [
      konteringContext.konteringValidationQueryLoading,
      loginStateContext.sign,
      fakturaattestContext.reservForData,
    ]
  );

  const konteringVyer = useMemo(() => {
    return [Kontering];
  }, []);

  const attestantVyer = useMemo(() => {
    return [Attestanter];
  }, []);

  const attestMeddelandeVyer = useMemo(() => {
    return [AttestMeddelande];
  }, []);

  const leverantorFaktura = useMemo(() => {
    return getBildFaktura(nodeData?._Associations?.Faktura);
  }, [nodeData?._Associations?.Faktura]);

  return (
    <AttestMessageContextProvider
      value={{
        messageEditModeID,
        messageReciverID,
        setHaveAttesterat,
        setMessageEditModeID,
        setMessageReciverID,
      }}
    >
      <BusinessDataForm<FakturaDelQuery_node_TEDLRFakturaDel>
        isNew={props.isNew}
        data={nodeData}
        model={fakturaDelModel}
        fullScreen={props.config?.fullPage ?? false}
        updateMutation={updateFunction}
        mutationError={error}
        mutationLoading={mutationLoading}
        validateFns={
          [
            validateKontering,
            validateMessage,
            validateFakturadelTillaggsinfo,
            validateKvittering,
            validateFakturadel,
            validatePeriodDates,
            validateSvenskMoms,
            validateUtlandskMoms,
          ] as IValidateFn[]
        }
        editMenuActions={[
          editMenuActionSkickaTillbakaFaktura,
          editMenuUndo,
          editMenuSave,
          editMenuAttestera,
          editMenuRetake,
        ]}
        overrideChoiceButtons={{ save: editMenuSave }}
        refetchData={refetch}
        dataLoading={
          nodeLoading || konteringContext.konteringValidationQueryLoading
        }
      >
        <FakturaDelContextManager>
          <>
            <ObjektVy
              adjustmentButtonsLabel="Justera bildbredd"
              canAdjustSidaVidSida
              editImplemented
              error={fakturaDelQueryError}
              nodeLoading={nodeLoading}
              minSideBySideWidths={[5, 4]}
              sidaVidSida={true}
              sideBySideWidths={[7, 5]}
              funktionsMenyItems={[
                {
                  id: 'fakturaattestPrintModal',
                  caption: 'Skriv ut',
                  iconType: 'print',
                  onClick: () => setPrintMenuOpen(true),
                },
                {
                  id: 'fakturaattestMailImage',
                  caption: 'Skicka fakturabild',
                  iconType: 'send',
                  onClick: () => setMailDialogOpen(true),
                },
                {
                  id: 'fakturaattestEventLog',
                  caption: 'Visa fakturalogg',
                  iconType: 'faktura_sida',
                  onClick: () => {
                    setEventLogModalOpen(true);
                  },
                },
              ]}
            >
              <ObjektVySida
                caption="Fakturabilder"
                sidNr={1}
                collectionName={fakturabildModel.CollectionName}
                smallScreenNoPadding
                disableFloatingMenuPadding
                hidden={isLarge}
              >
                <FakturaBilderComponent
                  leverantorfaktura={leverantorFaktura}
                  id={nodeData?._Associations?.Faktura?.id ?? null}
                  noPadding
                  useWheelToScroll
                />
              </ObjektVySida>
              <ObjektVySida
                caption="Faktura"
                sidNr={2}
                collectionName={fakturaDelModel.CollectionName}
                hidden={isLarge}
              >
                <ObjektVyKolumner>
                  <ObjektVyKolumn fullPage={props.config?.fullPage ?? false}>
                    <AttributGrupp readOnly>
                      <Attribut
                        name="Faktura.Leverantor.LeverantorNrNamn"
                        size="small"
                      />
                      <Attribut name="AttestMinaStatus" size="small" />
                      <Attribut name="Faktura.FORFALLO_DATUM" size="small" />
                      <Attribut name="Faktura.FAKTURA_NR" size="small" />
                      <Attribut
                        name="Faktura.FakturabeloppKredittext"
                        size="small"
                      />
                      <Attribut name="Faktura.FAKTURADATUM" size="small" />
                      <Attribut name="Faktura.DefAnkVernr" size="small" />

                      {nodeData?._Associations?.Faktura?.MomsBelopp2 !==
                        undefined &&
                        nodeData?._Associations?.Faktura?.MomsBelopp2 !== 0 && (
                          <Attribut name="Faktura.MomsBelopp2" size="small" />
                        )}
                    </AttributGrupp>
                    <ObjektVyKort
                      readOnly
                      vyer={attestantVyer}
                      caption="Attestanter"
                      bmod={levfaktAttestantModel}
                      button={() => (
                        <HandleCertifiersButton
                          onClick={() => {
                            if (haveChanges) {
                              setOpenChoiceDialog(true, () =>
                                setHandleCertifiersOpen(true)
                              );
                            } else {
                              setHandleCertifiersOpen(true);
                            }
                          }}
                        />
                      )}
                      id={nodeData?._Associations?.Faktura?.id ?? null}
                      config={{
                        parents: [
                          { id: nodeData?.id ?? null, associationName: '' },
                        ],
                      }}
                    />
                    <ObjektVyKort
                      vyer={konteringVyer}
                      // loading={nodeLoading || mutationLoading}
                      caption="Kontering"
                      button={() => (
                        <span>
                          {lrUseSnabbReg && (
                            <ShowFastRegButton
                              onClick={() => setFastRegOpen(true)}
                            />
                          )}

                          <ShowBokfKonteringarButton
                            onClick={() => setAdjustedKonteringarOpen(true)}
                          />
                          <ShowKodBehButton
                            onClick={() => setKodbehInfoOpen(true)}
                          />
                        </span>
                      )}
                      bmod={levfaktAttestantModel}
                      id={nodeData?._Associations?.Faktura?.id ?? null}
                      noPadding
                    />
                  </ObjektVyKolumn>
                  <ObjektVyKolumn fullPage={props.config?.fullPage ?? false}>
                    <ObjektVyKort
                      readOnly
                      vyer={attestMeddelandeVyer}
                      caption="Meddelanden"
                      button={() => <AttestMessageButtons />}
                      bmod={levfaktAttestantModel}
                      id={nodeData?._Associations?.Faktura?.id ?? null}
                    />

                    <ObjektVyKort caption="Dokument" readOnly>
                      <AssociationList
                        collectionName={'LRLeverantorfaktura'}
                        associationName={'Dokument'}
                        associationPath={'Faktura.Dokument'}
                        ownId={nodeData?._Associations?.Faktura?.id ?? null}
                        config={dokConfig}
                      />
                    </ObjektVyKort>
                  </ObjektVyKolumn>
                </ObjektVyKolumner>
              </ObjektVySida>
            </ObjektVy>
            {mutationLoading && <EDAvenyProgress />}

            {fastRegOpen && (
              <FakturaAttestSnabbRegModal
                open={fastRegOpen}
                setOpen={setFastRegOpen}
                id={props.id}
              ></FakturaAttestSnabbRegModal>
            )}

            {handleCertifiersOpen && (
              <FakturaAttestHandleCertifiersModal
                open={handleCertifiersOpen}
                onClose={() => setHandleCertifiersOpen(false)}
                dbName={activeDatabase ?? ''}
              />
            )}
            <FakturaattestMailFakturaBildModal
              onClose={() => setMailDialogOpen(false)}
              open={mailDialogOpen}
            />
            <FakturaAttestPrintModal
              open={printMenuOpen}
              onClose={() => setPrintMenuOpen(false)}
              dbName={activeDatabase ?? ''}
            />
            <ReturnFakturaDialog
              open={returnFakturaDialogOpen}
              setOpen={setReturnFakturaDialogOpen}
            />
            <KodbehInfoModal
              open={kodbehInfoOpen}
              onClose={() => setKodbehInfoOpen(false)}
            />
            {adjustedKonteringarOpen && (
              <BusinessDataFormContext.Consumer>
                {formContext => (
                  <BokfKonteringModal
                    bokfYear={
                      new Date(formContext?.data?.RegVerdatum)
                        .getFullYear()
                        .toString() ?? ''
                    }
                    noDataText={`Den här fakturan har bokförts annorlunda jämfört med hur den
                konterades i Fakturaattesten men det kunde inte hittas några bokförda
                konteringar.`}
                    open={adjustedKonteringarOpen}
                    onClose={() => setAdjustedKonteringarOpen(false)}
                    vernr={formContext?.data?.RegVernr}
                  />
                )}
              </BusinessDataFormContext.Consumer>
            )}

            {eventLogModalOpen && (
              <EventLogModal
                open={eventLogModalOpen}
                onClose={() => setEventLogModalOpen(false)}
                fakturaID={nodeData?._Associations?.Faktura?.id}
              />
            )}
          </>
        </FakturaDelContextManager>
      </BusinessDataForm>
    </AttestMessageContextProvider>
  );
};

const fakturaAttestObjektVy = collectionCompToObjektVy(
  Fakturadel,
  'FakturaAttest'
);

export const FakturaDelVyer: IObjektVy[] = [fakturaAttestObjektVy];
